import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ClockIcon from "../../Assets/Images/TimeSheet/Clock";
import TaskIcon from "../../Assets/Images/TimeSheet/Task";
import BreakIcon from "../../Assets/Images/TimeSheet/Break";
import moment from 'moment';
import { connect } from 'react-redux';

function ViewTimeSheet(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const data = location.state?.data?.allData;

  const calculateTotalHours = () => {
    if (
      !data.start_time || !data?.end_time ||
      !data?.start_date || !data?.end_date) {
      return '0hrs';
    }

    const clockInHour = data.start_time.split(' ')[0]?.split(":")[0];
    const clockInMin = data.start_time.split(' ')[0]?.split(":")[1];
    const clockInAmPm = data.start_time.split(' ')[1];

    const clockOutHour = data.end_time.split(' ')[0]?.split(":")[0];
    const clockOutMin = data.end_time.split(' ')[0]?.split(":")[1];
    const clockOutAmPm = data.end_time.split(' ')[1];


    const formattedStartDate = moment(data.StartDate).format('YYYY-MM-DD');
    const formattedEndDate = moment(data.EndDate).format('YYYY-MM-DD');

    const startDateTimeStr = `${formattedStartDate} ${clockInHour}:${clockInMin} ${clockInAmPm}`;
    const endDateTimeStr = `${formattedEndDate} ${clockOutHour}:${clockOutMin} ${clockOutAmPm}`;

    const start = moment(startDateTimeStr, 'YYYY-MM-DD hh:mm A');
    const end = moment(endDateTimeStr, 'YYYY-MM-DD hh:mm A');

    if (!start.isValid() || !end.isValid()) return '';

    if (end.isBefore(start)) {
      return 'End time cannot be before start time';
    }

    const duration = moment.duration(end.diff(start));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    return `${hours}Hrs ${minutes.toString().padStart(2, '0')}Mins`;
  };

  return (
      <div className='TaskEmployee-main mb-5'>
        <div className="page-title">
          <h4>Timesheet</h4>
          <div className="edit-btn">
            <button
              type="submit"
              className="custom-btn"
              onClick={() => navigate(-1)}
            >Cancel
            </button>
          </div>
        </div>

        <div className='row'>
          <div className='col-lg-7 col-md-7 col-sm-12'>
            <div className='View_Timesheet_Card'>
              <div className='head_timesheet'>
                <h6>Time Log Details</h6>
              </div>
              <div className='body_timesheet'>
                <div className='labeldiv_timesheet'>
                  <h5>Start Time</h5>
                  <h6>{moment(data?.start_date?.split(' ')[0])?.format('DD-MM-YYYY') || ""} {moment(data?.start_time, "HH:mm:ss")?.format('hh:mm A') || ""}</h6>
                </div>
                <div className='labeldiv_timesheet'>
                  <h5>End Time</h5>
                  <h6>{moment(data?.end_date?.split(' ')[0])?.format('DD-MM-YYYY') || ""} {moment(data?.end_time, "HH:mm:ss")?.format('hh:mm A') || ""}</h6>
                </div>
                {(() => {
                  const allTimers = data?.task?.taskTimerMap || [];
                  const taskDate = data?.start_date?.split(' ')[0];

                  let totalElapsedTime = 0;

                  allTimers.forEach((timer) => {
                    const timerDate = timer?.start_time?.split(' ')[0];

                    if (timerDate === taskDate && (data?.start_time == timer?.start_time?.split(' ')[1]) && timer?.duration && data?.end_time) {
                      const [hh, mm, ss] = timer.duration
                        .split(/[hms\s]+/)
                        .filter(Boolean)
                        .map(Number);
                      totalElapsedTime += (hh * 3600 + mm * 60 + ss);
                    }
                  });

                  const totalH = Math.floor(totalElapsedTime / 3600);
                  const totalM = Math.floor((totalElapsedTime % 3600) / 60);
                  const totalS = totalElapsedTime % 60;
                  const totalHoursLogged = `${totalH}h ${totalM}m ${totalS}s`;

                  if (!totalHoursLogged) return null;

                  return (

                    <div className='labeldiv_timesheet'>
                      <h5>Total Hours</h5>
                      <h6>{totalHoursLogged}</h6>
                    </div>
                  )
                })()}

                <div className='labeldiv_timesheet'>
                  <h5>Earnings</h5>
                  <h6>{data?.earnings || "₹0.00"}</h6>
                </div>
                <div className='labeldiv_timesheet'>
                  <h5>Memo</h5>
                  <h6>{data?.memo || "-"}</h6>
                </div>
                <div className='labeldiv_timesheet'>
                  <h5>Project</h5>
                  <h6>{data?.project?.name || "-"}</h6>
                </div>
                <div className='labeldiv_timesheet'>
                  <h5>Task</h5>
                  <h6>{data?.task?.title || '-'}</h6>
                </div>
                <div className='labeldiv_timesheet'>
                  <h5>Employee</h5>
                  <div className="timesheet-employee-info">
                    <img src={
                      `data:image/jpeg;base64,${btoa(
                        new Uint8Array(data?.task?.taskUserMap?.filter((item) => item?.userTaskMap?.id == props?.user?.id)?.[0]?.userTaskMap?.profile_pic?.data).reduce(
                          (data, byte) => data + String.fromCharCode(byte),
                          ''
                        )
                      )}`
                    } alt="Profile" />
                    <div className="employee-info-details">
                      <span>{data?.task?.taskUserMap?.filter((item) => item?.userTaskMap?.id == props?.user?.id)?.[0]?.userTaskMap?.name || ""}</span>
                      <span className="role">{data?.task?.taskUserMap?.filter((item) => item?.userTaskMap?.id == props?.user?.id)?.[0]?.userTaskMap?.designation?.name || ""}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-5 col-md-5 col-sm-12'>
            <div className='View_Timesheet_Card'>
              <div className='head_timesheet'>
                <h6>History</h6>
              </div>
              <div className='body_timesheet_history'>
                <ul>

                  <li>
                    <div className='history-part'>
                      <div className='row'>
                        <h6 className='col-lg-6'>
                          <ClockIcon /> Start Time
                        </h6>
                        <h6 className='col-lg-6'>{moment(data?.start_date?.split(' ')[0])?.format('DD-MM-YYYY') || ""} {moment(data?.start_time, "HH:mm:ss")?.format('hh:mm A') || ""}</h6>
                      </div>

                      <div className='row'>
                        <h6 className='col-lg-6'>
                          <TaskIcon /> Task
                        </h6>
                        <h6 className='col-lg-6'>{data?.task?.title || ""}</h6>
                      </div>

                      {(() => {
                        const allTimers = data?.task?.taskTimerMap || [];
                        const taskDate = data?.start_date?.split(' ')[0];
                        const taskStartTime = data?.start_time;

                        const matchedTimer = allTimers.find((timer) => {
                          const timerDate = timer?.start_time?.split(' ')[0];
                          const timerStartTime = timer?.start_time?.split(' ')[1];
                          return (
                            timerDate === taskDate &&
                            timerStartTime === taskStartTime &&
                            timer?.duration &&
                            data?.end_time &&
                            timer?.pause_time &&
                            timer?.resume_time
                          );
                        });

                        if (!matchedTimer) return null;

                        return (

                          <div className='row'>
                            <h6 className='col-lg-6'>
                              <BreakIcon /> Break
                            </h6>

                            <h6 className='col-lg-6'>
                              {moment(matchedTimer?.pause_time).format('hh:mm A')} -{' '}
                              {moment(matchedTimer?.resume_time).format('hh:mm A')}
                            </h6>
                          </div>
                        )
                      })()}

                      <div className='row'>
                        <h6 className='col-lg-6'>
                          <ClockIcon /> End Time
                        </h6>
                        <h6 className='col-lg-6'>{moment(data?.end_date?.split(' ')[0])?.format('DD-MM-YYYY') || ""} {moment(data?.end_time, "HH:mm:ss")?.format('hh:mm A') || ""}</h6>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.authenticationReducer.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ViewTimeSheet)